import type { FunctionComponent } from 'react';

import { useItemRecommendedAgents, usePositionRecommendedAgents } from './api/use-recommended-agents';
import { RecommendedAgentsList, type RecommendedAgentTaskOpener } from './RecommendedAgentsList';

export const ItemRecommendedAgents: FunctionComponent<{
    readonly architectureId: string;
    readonly itemId: string;
    readonly itemType: 'job-level' | 'job-role';
    readonly onOpenTask: RecommendedAgentTaskOpener | undefined;
}> = ({ architectureId, itemId, itemType, onOpenTask }) => {
    const query = useItemRecommendedAgents({ architectureId, itemId });

    return (
        <RecommendedAgentsList
            query={query}
            scope={{ architectureId, kind: 'job' }}
            subject={itemType}
            onOpenTask={onOpenTask}
        />
    );
};

export const PositionRecommendedAgents: FunctionComponent<{
    readonly architectureId: string;
    readonly onOpenTask: RecommendedAgentTaskOpener | undefined;
    readonly positionId: string;
}> = ({ architectureId, onOpenTask, positionId }) => {
    const query = usePositionRecommendedAgents({ architectureId, positionId });

    return (
        <RecommendedAgentsList
            query={query}
            scope={{ architectureId, kind: 'position' }}
            subject="position"
            onOpenTask={onOpenTask}
        />
    );
};
